import client from '../client';

export default {
  getProgramList: (data) =>
    client.get('seller/cc/bonus/programs/list', { params: data }).then((res) => res.data),
  //Seller ACC Bonus Program 详情
  getProgramDetail: (data) =>
    client.get(`seller/cc/bonus/programs/${data.programId}`, { params: data }).then((res) => res.data),
  //Seller ACC Bonus Program Campaign 明细
  getProgramCampaignDetail: (data) =>
    client.get(`seller/cc/bonus/programs/${data.programId}/campaigns`, { params: data }).then((res) => res.data),
  // Seller ACC Bonus Program Publisher 明细
  getProgramPublisherDetail: (data) =>
    client.get(`seller/cc/bonus/programs/${data.programId}/publishers`, { params: data }).then((res) => res.data),
  //取消 ACC Bonus Program 前预览
  getProgramCancelPreview: (data) =>
    client.get(`seller/cc/bonus/programs/${data.programId}/cancel-preview`, { params: data }).then((res) => res.data),
  //取消 ACC Bonus Program
  cancelProgram: (data) =>
    client.post(`seller/cc/bonus/programs/${data.programId}/cancel`, data).then((res) => res.data),
  //创建 ACC Bonus Program 前置校验
  getProgramPrecheck: (data) =>
    client.get(`seller/cc/bonus/programs/precheck`, { params: data }).then((res) => res.data),
  //创建 / 编辑时可选品牌列表
  getProgramBrandList: (data) =>
    client.get(`seller/cc/bonus/programs/eligible-brands`, { params: data }).then((res) => res.data),
  //创建/编辑：可选 Publisher 分页列表
  getProgramPublisherList: (data) =>
    client.get(`seller/cc/bonus/programs/eligible-publishers`, { params: data }).then((res) => res.data),
  //创建/编辑：可选 Campaign 分页列表
  getProgramCampaignList: (data) =>
    client.get(`seller/cc/bonus/programs/eligible-campaigns`, { params: data }).then((res) => res.data),
  //创建：ACC Bonus Program 创建
  createProgram: (data) =>
    client.post(`seller/cc/bonus/programs`, data).then((res) => res.data),
  //编辑 ACC Bonus Program 第一步 - 基础信息
  editProgramStep1: (data) =>
    client.post(`seller/cc/bonus/programs/${data.programId}/edit/step1`, data).then((res) => res.data),
  //编辑 ACC Bonus Program 第二步 - 奖励规则
  editProgramStep2: (data) =>
    client.post(`seller/cc/bonus/programs/${data.programId}/edit/step2`, data).then((res) => res.data),
  //编辑 ACC Bonus Program 第三步 - 联盟客
  editProgramStep3: (data) =>
    client.post(`seller/cc/bonus/programs/${data.programId}/edit/step3`, data).then((res) => res.data),
 
};
